const SalarySettings = () => import("./views/SalarySettings.vue");
const UploadedPaymentHistoryForm = () =>
  import("./views/UploadedPaymentHistoryForm.vue");
const UploadedPaymentHistorySettings = () =>
  import("./views/UploadedPaymentHistorySettings.vue");
const PaymentSchedule = () => import("./views/PaymentSchedule.vue");
const ConfirmSchedule = () => import("./views/ConfirmSchedule.vue");
// const PaymentUpload = () => import("./views/PaymentUpload.vue");
const AllApprovedPayment = () => import("./views/AllApprovedPayment.vue");
const ExportPayment = () => import("./views/ExportPayment.vue");
const AllPaymentUpload = () => import("./views/AllPaymentUpload.vue");
const PaymentUploadView = () => import("./views/PaymentUploadView.vue");
const ApprovedPaymentView = () => import("./views/ApprovedPaymentView.vue");
const PaymentOptions = () => import("./views/PaymentOptions.vue");
const UploadMandate = () => import("./views/UploadMandate.vue");
const MandateForm = () => import("./views/MandateForm.vue");
const PaymentOptionDetails = () => import("./views/PaymentOptionDetails.vue");

const AllApprovers = () =>
  import("@/components/general/approvals/AllApprovers.vue");
const AssignEmployeesAsApprovers = () =>
  import("@/components/general/approvals/AssignEmployeeToApprover.vue");
const ViewApprovers = () =>
  import("@/components/general/approvals/ViewApprovers.vue");
const CreateApprover = () =>
  import("@/components/general/approvals/CreateApprovers.vue");

import approverProps from "@/components/general/approvals/ApproverProps.js";
const { salaryManagement } = approverProps;
export default [
  {
    path: "payment-schedule",
    component: PaymentSchedule,
  },
  {
    path: "payment-schedule/confirm",
    name: "PaymentSchedule.confirm",
    component: ConfirmSchedule,
  },
  {
    path: "payment-upload",
    component: AllPaymentUpload,
  },
  {
    path: "payment-upload/view",
    name: "payment-upload-view",
    component: PaymentUploadView,
  },
  {
    path: "approved-payment",
    component: AllApprovedPayment,
  },
  {
    path: "approved-payment/view/:id",
    name: "approved-payment-view",
    component: ApprovedPaymentView,
  },
  {
    path: "payment-upload/:id/export",
    component: ExportPayment,
  },
  {
    path: "settings",
    component: SalarySettings,
  },
  {
    path: "settings/payment-options",
    component: PaymentOptions,
  },
  {
    path: "settings/payment-options/upload-mandate/:id",
    component: UploadMandate,
  },
  {
    path: "settings/payment-options/create",
    component: MandateForm,
  },
  {
    path: "settings/payment-options/view/:id",
    component: PaymentOptionDetails,
  },
  {
    path: "settings/upload-payment-history",
    component: UploadedPaymentHistoryForm,
  },
  {
    path: "settings/upload-payment-history/create",
    component: UploadedPaymentHistorySettings,
  },
  {
    path: "settings/approvers",
    component: AllApprovers,
    props: salaryManagement,
  },
  {
    path: "settings/approvers/assign/:id",
    component: AssignEmployeesAsApprovers,
    props: salaryManagement,
  },
  {
    path: "settings/approvers/edit/:id",
    component: CreateApprover,
    props: salaryManagement,
  },
  {
    path: "settings/approvers/view/:id",
    component: ViewApprovers,
    props: salaryManagement,
  },
  {
    path: "settings/approvers/create",
    component: CreateApprover,
    props: salaryManagement,
  },
];
